import UserAutocompleteInput from '../inputs/UserAutocompleteInput';
import createField from './createField';

const UserAutocompleteField = createField(UserAutocompleteInput, {
  commitWarningOnChange: true,
});

export default UserAutocompleteField;
